import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scroll = () => {
      window.scrollTo(0, 0);
    };

    return () => {
      scroll();
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
